const sidebarRoutes = [
  //dashboard
    { label: "Dashboard", path: "/admin" },
    { label: "Analytics", path: "/admin/analytics" },

  //tasks routes
    { path: "/admin/tasks", label: "All Tasks" },
    { label: "Locate", path: "/admin/locate" },
    { label: "Task Target", path: "/admin/TaskTarget" },
    { label: "Completed Task", path: "/admin/completedtask" },
    { label: "Planner", path: "/admin/Planner" },

  //manage routes
  { label: "Visit Profiles", path: "/admin/visitProfiles" },
  { label: "Employees", path: "/admin/employees" },
  { label: "Permissions", path: "/admin/permission" },
  { label: "Permission Group", path: "/admin/permissionGroup" },
  { label: "Office Locations", path: "/admin/officeLocations" },
  { label: "Teams", path: "/admin/teams" },
  { label: "Products", path: "/admin/products" },
  { label: "Designations", path: "/admin/designations" },
  { label: "Designation Level", path: "/admin/designationLevel" },
  { label: "Departments", path: "/admin/departments" },
  { label: "Doctors", path: "/admin/doctors" },
  { label: "Doctor Ranks", path: "/admin/doctorRanks" },
  { label: "Doctor Specializations", path: "/admin/doctorSpecializations" },
  { label: "Practice Locations", path: "/admin/practiceLocations" },
  { label: "Location Types", path: "/admin/locationTypes" },
  { label: "Employment Statuses", path: "/admin/employmentStatuses" },
  { label: "Customer Rank", path: "/admin/CustomerRank" },
  { label: "Task Statuses", path: "/admin/taskStatuses" },
  { label: "Task Types", path: "/admin/taskTypes" },
  { label: "Task Priorities", path: "/admin/taskPriorities" },
  { label: "Cities", path: "/admin/cities" },
  { label: "Countries", path: "/admin/countries" },
  { label: "Roles", path: "/admin/roles" },
  { label: "Sub Tasks", path: "/admin/subTasks" },

  //forms
  { label: "Forms", path: "/admin/forms" },

];

export default sidebarRoutes;

